module.exports = __webpack_public_path__ + "img/arrow-pointer-up.f614f653.svg";